/*
 * @Date: 2025-08-22 08:57:19
 */
import { http2 } from "../../utils/http/index";

export function post(url, data, config) {
  return http2.post(url, data, config);
}
// 获取oss信息
export const stsToken = (data) => post("/kukeopen/encrypt/oss/stsToken", data, { encrypt: 'AES' });
